import React from 'react';
import { Star, Twitter, Github, Disc } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="relative z-10 bg-[#05081c] border-t border-slate-800 pt-16 pb-8" data-id="element-29">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-31">
          <div className="col-span-1 md:col-span-1" data-id="element-32">
            <div className="flex items-center gap-2 mb-4" data-id="element-33">
              <Star className="h-6 w-6 text-cyan-400 fill-cyan-400/20" data-id="element-34" />
              <span className="font-heading text-2xl font-bold text-white" data-id="element-35">
                Starkeep
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6" data-id="element-36">
              Professional stargazing tools for the modern astronomer. Discover
              the universe with clarity and precision.
            </p>
            <div className="flex space-x-4" data-id="element-37">
              <a href="#" className="text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-38">
                <Twitter className="w-5 h-5" data-id="element-39" />
              </a>
              <a href="#" className="text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-40">
                <Github className="w-5 h-5" data-id="element-41" />
              </a>
              <a href="#" className="text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-42">
                <Disc className="w-5 h-5" data-id="element-43" />
              </a>
            </div>
          </div>

          <div data-id="element-44">
            <h4 className="text-white font-bold mb-4" data-id="element-45">Product</h4>
            <ul className="space-y-2 text-sm text-slate-400" data-id="element-46">
              <li data-id="element-47">
                <a href="#features" className="hover:text-cyan-400 transition-colors" data-id="element-48">
                  Features
                </a>
              </li>
              <li data-id="element-49">
                <a href="#pricing" className="hover:text-cyan-400 transition-colors" data-id="element-50">
                  Pricing
                </a>
              </li>
              <li data-id="element-51">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-52">
                  API
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-54">
                  Changelog
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-55">
            <h4 className="text-white font-bold mb-4" data-id="element-56">Company</h4>
            <ul className="space-y-2 text-sm text-slate-400" data-id="element-57">
              <li data-id="element-58">
                <a href="#team" className="hover:text-cyan-400 transition-colors" data-id="element-59">
                  About
                </a>
              </li>
              <li data-id="element-60">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-61">
                  Careers
                </a>
              </li>
              <li data-id="element-62">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-63">
                  Blog
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="hover:text-cyan-400 transition-colors" data-id="element-65">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-66">
            <h4 className="text-white font-bold mb-4" data-id="element-67">Location</h4>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-68">
              Limassol, Cyprus
              <br data-id="element-69" />
              Mediterranean Coast
              <br data-id="element-70" />
              <span className="text-xs text-slate-600 mt-2 block" data-id="element-71">
                No phone support available
              </span>
            </p>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-72">
          <p className="text-slate-500 text-sm" data-id="element-73">
            © 2026 Starkeep. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm text-slate-500" data-id="element-74">
            <a href="#" className="hover:text-slate-300 transition-colors" data-id="element-75">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-slate-300 transition-colors" data-id="element-76">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}